var _g, _g2, _g3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrashSettingsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_179_30021)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 60C46.5685 60 60 46.5685 60 30C60 13.4315 46.5685 0 30 0C13.4315 0 0 13.4315 0 30C0 46.5685 13.4315 60 30 60Z",
    fill: "#9D4C36"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ii_179_30021)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.9998 55.2274C43.9325 55.2274 55.2271 43.9327 55.2271 30C55.2271 16.0674 43.9325 4.77271 29.9998 4.77271C16.0671 4.77271 4.77246 16.0674 4.77246 30C4.77246 43.9327 16.0671 55.2274 29.9998 55.2274Z",
    fill: "#220A06"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_ii_179_30021)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.1133 55.2121C29.4076 55.2222 29.7032 55.2274 30 55.2274C43.9327 55.2274 55.2273 43.9327 55.2273 30C55.2273 16.0674 43.9327 4.77271 30 4.77271C29.7032 4.77271 29.4076 4.77783 29.1133 4.788C42.6353 5.25511 53.4539 16.3642 53.4539 30C53.4539 43.6359 42.6353 54.745 29.1133 55.2121Z",
    fill: "#261610"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.6318 4.77271L34.9252 5.038L34.1535 5.11572L30.4795 8.41451L35.6836 5.41585L37.6318 4.77271Z",
    fill: "#251610"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25169 38.527L4.77246 43.7766L6.74477 39.7972L9.56388 39.3014L6.25169 38.527Z",
    fill: "#251610"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1143 51.6552C14.1143 51.6552 19.9669 57.3121 25.9267 59.3059C20.5082 56.5323 14.1143 51.6552 14.1143 51.6552Z",
    fill: "#251610"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9842 34.6414C58.9842 34.6414 56.3018 43.013 50.7734 45.615C54.1071 42.3644 58.9842 34.6414 58.9842 34.6414Z",
    fill: "#251610"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0381 17.0138L51.9501 22.1643C51.9501 22.1643 46.1323 20.2027 41.0381 17.0138Z",
    fill: "#79554B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8234 8.48413C16.8234 8.48413 6.10966 13.8517 4.77246 28.8959C5.9864 18.7074 7.50046 14.4037 16.8234 8.48145V8.48413Z",
    fill: "#D4B997"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7969 9.88561C10.7969 9.88561 17.0407 2.45194 32.4306 2.12769C22.6763 3.64443 17.2337 4.09731 10.7969 9.88561Z",
    fill: "#251610"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.1876 38C38.1284 38 38.0716 37.977 38.0299 37.9362L30.1577 30.2338C30.0707 30.1487 29.9293 30.1487 29.8423 30.2338L21.9701 37.9362C21.9283 37.977 21.8716 38 21.8124 38L20.223 38C20.0249 38 19.9255 37.7667 20.0654 37.6298L29.8423 28.0638C29.9293 27.9787 30.0707 27.9787 30.1577 28.0638L39.9346 37.6298C40.0745 37.7667 39.9751 38 39.777 38L38.1876 38Z",
    fill: "#FFE500"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.1876 33C38.1284 33 38.0716 32.977 38.0299 32.9362L30.1577 25.2338C30.0707 25.1487 29.9293 25.1487 29.8423 25.2338L21.9701 32.9362C21.9283 32.977 21.8716 33 21.8124 33L20.223 33C20.0249 33 19.9255 32.7667 20.0654 32.6298L29.8423 23.0638C29.9293 22.9787 30.0707 22.9787 30.1577 23.0638L39.9346 32.6298C40.0745 32.7667 39.9751 33 39.777 33L38.1876 33Z",
    fill: "#FFE500"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_179_30021",
    x: 0,
    y: 0,
    width: 60,
    height: 61,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.741176 0 0 0 0 0.533333 0 0 0 0 0.47451 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_179_30021"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ii_179_30021",
    x: 4.77246,
    y: 4.77271,
    width: 50.4551,
    height: 50.4547,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_179_30021"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_179_30021",
    result: "effect2_innerShadow_179_30021"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ii_179_30021",
    x: 29.1133,
    y: 4.77271,
    width: 26.1143,
    height: 50.4547,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_179_30021"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_179_30021",
    result: "effect2_innerShadow_179_30021"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrashSettingsIcon);
export default __webpack_public_path__ + "static/media/crash-settings-icon.9cd2fef9ee956d11536691a84bd6c04f.svg";
export { ForwardRef as ReactComponent };